import { clientTranscript } from "../config/axios";
import { clientAWS } from "../config/awsConfig";
import { ParamsData } from "../components/upload_audio/paramsData";
import { uploadFile } from "./aws.service";
export const BucketName = "mentu-class-audios";
export const getTranscriptsByID = async (id) => {
  if (id != null) {
    const response = await clientTranscript.get(`/transcriptions/${id}`);
    return response.data;
  }
  return;
};

export const uploadAudio = async (
  userData,
  audioFile,
  customName,
  dispatch,
  createKey
) => {
  const s3 = clientAWS();
  s3.upload(ParamsData({ userData, audioFile, customName, createKey }))
    .on("httpUploadProgress", (progress) => {
      const percent = Math.round((progress.loaded / progress.total) * 100);
      dispatch({ type: "UPDATE_PROGRESS", payload: percent });
    })
    .send((err, data) => {
      if (err) {
        dispatch({
          type: "UPLOAD_FAILURE",
          payload: "Error al subir el archivo.",
        });
        console.error("Error al subir el archivo:", err);
      } else {
        dispatch({ type: "UPLOAD_SUCCESS", key: data.Key });
        dispatch({ type: "SET_CUSTOM_NAME", payload: "" });
      }
    });
};

export const getTranscriptionFinal = async (audioUrl) => {
  const s3 = clientAWS();

  const params = {
    Bucket: BucketName,
    Key: audioUrl,
  };

  try {
    const data = await s3.getObject(params).promise();
    const jsonData = JSON.parse(data.Body.toString("utf-8"));

    return getTeacher(jsonData.utterances);
  } catch (err) {
    throw err;
  }
};

const getTeacher = (utterances) => {
  const docenteExists = utterances.some(
    (utterance) => utterance.speaker === "Docente"
  );

  if (docenteExists) {
    return { utterances };
  }

  const tiempos = {};

  utterances.forEach((utterance) => {
    const speaker = utterance.speaker;
    const duracion = utterance.end_time - utterance.start_time;
    if (!tiempos[speaker]) {
      tiempos[speaker] = 0;
    }
    tiempos[speaker] += duracion;
  });

  let maxSpeaker = null;
  let maxTime = 0;

  for (const speaker in tiempos) {
    if (tiempos[speaker] > maxTime) {
      maxTime = tiempos[speaker];
      maxSpeaker = speaker;
    }
  }

  utterances.forEach((utterance) => {
    if (utterance.speaker === maxSpeaker) {
      utterance.speaker = "Docente";
    }
  });

  const utterancesJson = {
    utterances: utterances,
  };
  return utterancesJson;
};

export const uploadTranscriptionToS3 = async (audioUrl, transcriptionData) => {
  const s3 = clientAWS();

  const params = {
    Bucket: BucketName,
    Key: audioUrl,
    Body: JSON.stringify(transcriptionData),
    ContentType: "application/json",
  };

  try {
    const data = await s3.putObject(params).promise();
    return data;
  } catch (err) {
    console.error("Error al subir el objeto a S3:", err);
    throw err;
  }
};

export const uploadTranscription = async (audioUrl, transcriptionData) => {
  const params = {
    Key: audioUrl,
    ContentType: "application/json",
  };
  await uploadFile(params, JSON.stringify(transcriptionData));
}

export const uploadAudioFile = async (
  userData,
  audioFile,
  customName,
  dispatch,
  createKey,
  planning = null
) => {
  await uploadFile(ParamsData({ userData, audioFile, customName, createKey,planning }), audioFile, { dispatch });
}

export const createTranscription = async (Key, { onDataChange }) => {
  clientTranscript.post(`/transcript/create`, { Key }, {
    onDownloadProgress: (progressEvent) => {
      onDataChange(JSON.parse(progressEvent.event.target.response?.split('\n\n')?.reverse?.()[1]), {});
    }
  })
}

export const listTranscription = async (profile_id) => {
  const res = await clientTranscript.get(`/transcript/${profile_id}`);
  return res.data;
}
